module.exports = __webpack_public_path__ + "static/play-store_badge--white-025d7e2c3e611ad5776260d0a114dae2.svg";